import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';



import { ServicoOfflineTarifaFaixaEtaria } from '../../model';

import { GERENCIAMENTO, ITENSPORPAGINA } from '../../app.config';

@Injectable()
export class ServicoOfflineTarifaFaixaEtariaService{

  constructor(private http: HttpClient){}


    buscarPorParametro(param: string, pagina: Number, idtarifa : number): Observable<any>{

      const headers = new HttpHeaders().set('noloader', 't');

      if (param.length > 0){
        return this.http.get<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetaria/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}&IdTarifa=${idtarifa}`, {headers: headers});
      }else{
        return this.http.get<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetaria/?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}&IdTarifa=${idtarifa}`, {headers: headers});
      }
    }

    buscarPorId(id: number): Observable<any>{
        return this.http.get<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetaria/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any>{
      return this.http.delete<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetaria/${id}`);
    }

    salvar(servicoofflinetarifafaixaetaria: ServicoOfflineTarifaFaixaEtaria): Observable<any>{
      if (servicoofflinetarifafaixaetaria.Id > 0){
        return this.http.put<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetaria/${servicoofflinetarifafaixaetaria.Id}`, servicoofflinetarifafaixaetaria);
      }else{
        return this.http.post<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetaria/`, servicoofflinetarifafaixaetaria);
      }
    }

    salvarListaPrivativo(listaServicoofflinetarifafaixaetaria: ServicoOfflineTarifaFaixaEtaria[]): Observable<any>{
      if (listaServicoofflinetarifafaixaetaria[0].Id > 0){
        return this.http.put<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetariaPrivativo/`, listaServicoofflinetarifafaixaetaria);
      }else{
        return this.http.post<any>( `${GERENCIAMENTO}/api/offlineservicotarifafaixaetariaPrivativo/`, listaServicoofflinetarifafaixaetaria);
      }
    }

  }
